import React, { useCallback } from "react";
import { Button, Modal } from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import ee from "../../services/EventEmitter";
import { MODAL } from "../../constants/translates";
import EditDeclarant from "../declarants/editDeclarant";
import SettingsStore from "../../stores/SettingsStore";
import {DeepPartial} from "../../models/Common";
import {Declarant} from "../../models/Declarant";

type Props = {
  deleteEntity: {
    entityId: unknown;
    eventKey: string;
  },
  editEntity: {
    entity: DeepPartial<Declarant>;
  },
  settingsStore: SettingsStore,
}

const DeclarantActions: React.FC<Props> = ({ deleteEntity, settingsStore, editEntity }) => {
  const onDeleteHandler = useCallback(() => {
    Modal.confirm({
      title: MODAL.confirm_title,
      content: MODAL.confirm_delete,
      onOk: () => {
        ee.emit(deleteEntity.eventKey, deleteEntity.entityId);
      },
    });
  }, [deleteEntity]);

  return (
    <div className={'row-container'}>
      <Button className={'icon-button'} type="primary" onClick={onDeleteHandler}>
        <DeleteOutlined />
      </Button>
      <EditDeclarant
        entity={editEntity.entity}
        clients={settingsStore.clients || []}
        noClient={settingsStore.noClient}
        departments={settingsStore.departments || []}
      />
    </div>
  );
};

export default DeclarantActions;
